import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useEffect, useState } from 'react';
import { DialogContent, TextField } from '@mui/material';
import { TEditDescriptionDialogProps } from './types';

export const EditDescriptionDialog: FC<TEditDescriptionDialogProps> = ({
	open,
	setClose,
	handleEdit,
	descriptionText,
}) => {
	const [description, setDescription] = useState<string>(descriptionText);
	useEffect(() => {
		setDescription(descriptionText);
	}, [descriptionText]);
	return (
		<Dialog
			open={open}
			onClose={setClose}
			sx={{
				'& .MuiDialog-paper': {
					width: '500px',
					maxWidth: '500px',
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle color="primary">Edit Description</DialogTitle>
			<DialogContent
				sx={{
					p: '0 12px 0px 12px',
				}}
			>
				{/* <Notice
					sx={{
						margin: '0px!important',
					}}
					text="Add the new DESCRIPTIONs you want to add to the system. Each DESCRIPTION should be on a new line."
				/> */}
				<TextField
					sx={{
						mt: '12px',
						'& .MuiInputBase-root': {
							padding: '6px 8px',
							lineHeight: '1.5',
							borderRadius: '12px',
							// fontSize: '0.9rem',
						},
					}}
					autoFocus
					label="Description"
					value={description}
					onChange={(e) => setDescription(e.target.value)}
					type="text"
					fullWidth
					multiline
					rows={4}
				/>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={setClose}
					sx={{
						textTransform: 'none',
					}}
				>
					Cancel
				</Button>
				<Button
					onClick={() => handleEdit(description)}
					autoFocus
					sx={{
						textTransform: 'none',
					}}
				>
					Send
				</Button>
			</DialogActions>
		</Dialog>
	);
};
